import type { BorderRadius } from '@seek/cmsu-cms-connect';
import { Box, Loader } from 'braid-design-system';
import React, { useState } from 'react';

import * as styles from './Video.css';
import { getVideoType, getVideoUrl, type VideoSrcType } from './helper';

interface Props {
  url: string;
  type?: VideoSrcType;
  size?: 'small' | 'medium' | 'large';
  borderRadius?: Exclude<BorderRadius, 'full'>;
  alignX?: 'left' | 'center' | 'right';
}

export const Video = ({
  url,
  type,
  size,
  borderRadius,
  alignX = 'center',
}: Props) => {
  const [loaded, setLoaded] = useState(false);
  const newVideoUrl = getVideoUrl(url);
  const videoType = getVideoType(newVideoUrl);

  if (!videoType && !type) {
    return <></>;
  }

  return (
    <Box>
      <Box className={[styles.size[size || 'large'], styles.alignX[alignX]]}>
        <Box
          className={styles.videoWrapper}
          borderRadius={borderRadius || 'large'}
          display="flex"
          justifyContent="center"
        >
          {!loaded && <Loader aria-label="video loading" size="large" />}
          <Box
            component="iframe"
            className={[
              styles.video,
              styles.borderRadius[borderRadius || 'large'],
              styles.size[size || 'large'],
            ]}
            src={newVideoUrl}
            frameBorder="0"
            onLoad={() => setLoaded(true)}
            allowFullScreen
            borderRadius={borderRadius || 'large'}
          />
        </Box>
      </Box>
    </Box>
  );
};
